<div class="main-wrap">
  <h3 class="title">
    LV Connect
  </h3>
  <div>
    <p-progressSpinner></p-progressSpinner>
    <p>redirecting...</p>
  </div>
</div>